import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow,
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Referral
      </PageHeader>

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasReferralProgram, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.LLMPricingReferral}
          label="✨ Enhance with AI"
          hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisPricing, "1")}
        />
        <TextRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.LLMPricingReferral, "1")}>
          <div className="rainbowPower">
            Your AI assistant will enhance the answer below using contextual data from the customer’s profile, conversation history, and your
            knowledge graph.
          </div>
        </TextRow>

        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FeatureReferral1} />
        <TextAreaRow
          {...page}
          marginTop
          label=" Message 2 (Optional)"
          keyName={LocationVarKey.FeatureReferral2}
          enableSwitchVar={LocationVarKey.FeatureReferral2Enabled}
        />
      </Section>
      <SwitchRow {...page} keyName={LocationVarKey.AllowsReferralsInChat} label="Allow users to provide referrals in chat" />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasReferralProgram, "1")}>
        <SwitchRow {...page} keyName={LocationVarKey.AfterNavigateReferral} label="Ask if they want to be navigated to your Referral Program URL" />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateReferral, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader {...page}> After Navigate</SectionHeader>
          <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AfterNavigateReferral1} />
          <TextAreaRow
            {...page}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateReferral2}
            enableSwitchVar={LocationVarKey.AfterNavigateReferral2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
